import * as axiosBaseClient from './axiosBaseClient';
import configurations from '../config.json';
import { apiUrl } from "../httpCommon";

const baseURL = apiUrl();

export const getOracleVendor = (oracleVendorId) => {
  const url = `${baseURL}${configurations.ORACLE_VENDOR_END_POINT}?recId=${oracleVendorId}`;
  return axiosBaseClient.httpGet(url);
};

export const updateOracleVendor = (oracleSupplierData) => {
  const url = `${baseURL}${configurations.ORACLE_VENDOR_END_POINT}`;
  return axiosBaseClient.httpPatch(url, oracleSupplierData);
}
